<template>
    <div class="project-partners">
        <z-caption size="2xl" weight="600" class="u-bottom-margin--l-important">{{ textLocalize.title }}</z-caption>
        <div v-if="!isSended">
            <form class="project-partners__form" @submit.prevent="onSubmit">
                <div class="row">
                    <div class="col-default-12">
                        <z-select
                            v-model="formValues.program"
                            :options="programsList"
                            :placeholder="textLocalize.programs"
                            required
                            ref="programsField"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-default-12">
                        <z-input
                            v-model="formValues.institutionName"
                            name="firstName"
                            :placeholder="textLocalize.institutionName"
                            clearable
                            required
                            ref="institutionNameField"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-default-12">
                        <z-input
                            v-model="formValues.fio"
                            name="firstName"
                            :placeholder="textLocalize.fio"
                            clearable
                            required
                            ref="fioField"
                        />
                    </div>

                </div>

                <div class="row">
                    <div class="col-default-12">
                        <z-input
                            v-model="formValues.position"
                            name="firstName"
                            :placeholder="textLocalize.position"
                            clearable
                            required
                            ref="positionField"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues.phone"
                            name="phoneNumber"
                            type="tel"
                            :mask="{mask: '+{7} (000) 000-00-00'}"
                            :placeholder="textLocalize.phone"
                            clearable
                            required
                            ref="phoneField"
                        />
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues.email"
                            name="email"
                            type="email"
                            :placeholder="textLocalize.email"
                            clearable
                            required
                            ref="emailField"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-default-12 u-top-margin--m">
                        <z-input-file
                            name="file"
                            accept=".pdf, .doc, .xls, .zip, .rar"
                            size="m"
                            :max-size="20971520"
                            :show-accept-label="true"
                            @change="updateFileField"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-default-12">
                        <z-checkbox
                            :data="{
                                text: textLocalize.agreement,
                                id: 'agreement'
                            }"
                            size="m"
                            required
                            ref="agreementField"
                        />
                    </div>
                </div>

                <div class="row">

                    <div class="col-default-12">
                        <p class="career-registration__notification">
                            {{ textLocalize.required }}
                        </p>
                        <z-button
                            type="submit"
                            class="u-mt-l"
                        >
                            {{ textLocalize.submit }}
                        </z-button>

                        <p class="text-size-s border-error-text u-mt-2xs" v-if="errorMsg" v-html="errorMsg"></p>
                    </div>
                </div>
            </form>
        </div>

        <p class="text-size-xl u-semi-bold" v-else>
            {{ textLocalize.success }}
        </p>
    </div>
</template>

<script setup>
import {onMounted, ref} from 'vue'
import { sendProgramPartners } from '@/api/program-partners';
import { useGetter } from '@/composable/useGetter'
import { buildFormData } from '@/composable/useBuildFormData'
import { useRecaptcha } from '@/composable/useRecaptcha'
import { textLocalize } from './data/partnersData.js'

const {app} = useGetter(['app'])
const { initGRecaptcha, getRecaptchaToken } = useRecaptcha()

const programsList = mergeArrays(app.value.components['program-registration-form'])

const isSended = ref(false)
const errorMsg = ref('')

const formValues = ref({
    program: '',
    institutionName: '',
    fio:'',
    position: '',
    phone: '',
    email:'',
    file: '',
})

const programsField = ref(null)
const institutionNameField = ref(null)
const fioField = ref(null)
const positionField = ref(null)
const phoneField = ref(null)
const emailField = ref(null)
const agreementField = ref(null)

const requiredFields = [programsField, institutionNameField, fioField, positionField, phoneField, emailField, agreementField]

const updateFileField = (file) => {
    formValues.value.file = file?.[0]
}

const onSubmit = async () => {
    let isValid = true

    requiredFields.forEach(item => {
        if (item.value) {
            item.value?.validate()
            if (item.value.error) {
                isValid = false
            }
        }
    })

    if (!isValid) return

    try {
        const recaptchaToken = await getRecaptchaToken()

        if (!recaptchaToken) {
            throw new Error('Failed to get reCAPTCHA token');
        }

        formValues.value.captcha = recaptchaToken
        sendForm()
    } catch (error) {
        console.error(error)
    }
}

const sendForm = () => {
    const formData = buildFormData(formValues.value)
    sendProgramPartners(formData)
        .then(data => {
            if (data.status === 'error') {
                errorMsg.value = data.message
            } else {
                isSended.value = true
            }
        })
        .catch(e => {
            console.log(e);
            errorMsg.value = textLocalize.sendError
        })
}

onMounted(()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const programId = urlParams.get('program');

    if (programId) {
        const program = programsList.find(item => item.id === programId);

        if (program) {
            formValues.value.program = program.id;
        }
    }

    initGRecaptcha()
})

function mergeArrays(obj) {
    const mergedArray = [];

    for (const key in obj) {
        if (Array.isArray(obj[key])) {
            mergedArray.push(...obj[key]);
        }
    }

    return mergedArray;
}
</script>

<style lang="scss">
</style>
